var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumberThree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#ABDFCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.288 37.54C24.824 37.54 23.42 37.42 22.076 37.18C20.756 36.964 19.604 36.628 18.62 36.172V33.148C20.852 34.156 23.252 34.66 25.82 34.66C28.028 34.66 29.66 34.264 30.716 33.472C31.796 32.656 32.336 31.504 32.336 30.016C32.336 28.48 31.784 27.388 30.68 26.74C29.576 26.068 27.896 25.732 25.64 25.732H22.688V22.78H25.568C27.368 22.78 28.82 22.42 29.924 21.7C31.028 20.956 31.58 19.876 31.58 18.46C31.58 17.068 31.124 16.012 30.212 15.292C29.3 14.572 27.98 14.212 26.252 14.212C24.908 14.212 23.696 14.368 22.616 14.68C21.536 14.992 20.42 15.508 19.268 16.228V13.204C21.38 11.932 23.852 11.296 26.684 11.296C29.492 11.296 31.628 11.92 33.092 13.168C34.556 14.416 35.288 16.144 35.288 18.352C35.288 19.696 34.928 20.872 34.208 21.88C33.488 22.888 32.408 23.668 30.968 24.22C32.6 24.604 33.848 25.3 34.712 26.308C35.6 27.316 36.044 28.588 36.044 30.124C36.044 32.404 35.264 34.216 33.704 35.56C32.144 36.88 29.672 37.54 26.288 37.54Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberThree);
export default __webpack_public_path__ + "static/media/numberThree.9fe49cfe8cf24a2133008d29b614aab1.svg";
export { ForwardRef as ReactComponent };